<div class="card shadow border-0 mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-file-earmark-bar-graph me-2 text-primary"></i>Accounting</h2>
  </div>

  <div class="card-body">
    <form [formGroup]="filters" (ngSubmit)="fetchAll()">
      <div class="row g-3">
        <div class="col-auto">
          <app-date-range-selector (dateChanged)="updateRange($event)"
            (init)="onDateRangeInit($event)"
            [shortTimezone]="true"
          [showTimezone]="false"></app-date-range-selector>
        </div>

        <div class="col-3">
          <label class="form-label small fw-bold">Status</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-person-check"></i></span>
            <app-dropdown-select [multiple]="true" formControlName="status">
              @for (invoiceStatus of invoiceStatusList; track invoiceStatus) {
                <app-dropdown-select-option [value]="invoiceStatus">
                  {{ 'invoiceStatus.' + invoiceStatus | translate }}
                </app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col-auto">
          <label class="form-label small fw-bold">Deferred</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-clock"></i></span>
            <select formControlName="deferred" class="form-control">
              <option value="">All</option>
              <option [value]="1">Yes</option>
              <option [value]="0">No</option>
            </select>
          </div>
        </div>

        <div class="col d-flex align-items-end justify-content-end gap-1">
          <button type="submit" class="btn btn-primary fw-bold">Apply</button>
          <button (click)="downloadMode = 'csv'" [class.active]="downloadMode === 'csv'" type="button"
            class="btn btn-outline-primary">CSV
          </button>
          <button (click)="downloadMode = 'zip'" [class.active]="downloadMode === 'zip'" type="button"
            class="btn btn-outline-primary">ZIP
          </button>
        </div>
      </div>
    </form>

    <div class="table-responsive">
      <table class="table table-striped table-hover align-middle mt-2">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
            <th scope="col">
              <input type="checkbox" (change)="toggleSelectAll($event)" [checked]="isAllSelected()">
            </th>
            <th tableSorterHeader="startingAt">Period</th>
            <th tableSorterHeader="partnerName">Affiliate</th>
            <th tableSorterHeader="reference">Ref/Number</th>
            <th tableSorterHeader="amountTaxExcl">Excl. VAT</th>
            <th tableSorterHeader="vatPercent">VAT</th>
            <th tableSorterHeader="amountTaxIncl">Incl. VAT</th>
            <th tableSorterHeader="paymentTerms">Terms</th>
            <th tableSorterHeader="accountedAt">Accounted</th>
            <th tableSorterHeader="status">Status</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (billingRequest of billingRequests; track billingRequest) {
            <tr [class.table-active]="isSelected(billingRequest)">
              <td>
                <input type="checkbox" class="selectRow" (click)="selectBillingRequest(billingRequest)"
                  [checked]="isSelected(billingRequest)">
              </td>
              <td>{{ billingRequest.startingAt | date: 'dd/MM/yyyy' }}
                - {{ billingRequest.endingAt | date: 'dd/MM/yyyy' }}
              </td>
              <td>{{ billingRequest.partnerDetails?.companyName }} ({{ billingRequest.partnerId }})</td>
              <td>{{ billingRequest.invoice?.reference }}</td>
              <td>
                @if (billingRequest.deferred) {
                  {{ billingRequest.currencyTotalAmountTaxExcl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                }
                @if (!billingRequest.deferred && billingRequest.invoice) {
                  {{ billingRequest.invoice.currencyTotalAmountTaxExcl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                }
              </td>
              <td>
                @if (billingRequest.deferred) {
                  {{ billingRequest.getVatPercent() / 100 | percent }}
                }
                @if (!billingRequest.deferred && billingRequest.invoice) {
                  {{ billingRequest.invoice.getVatPercent() / 100 | percent }}
                }
              </td>
              <td>
                @if (billingRequest.deferred) {
                  {{ billingRequest.currencyTotalAmountTaxIncl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                }
                @if (!billingRequest.deferred && billingRequest.invoice) {
                  {{ billingRequest.invoice.currencyTotalAmountTaxIncl | money:2:$safeNavigationMigration(billingRequest.paymentCurrency?.isoCode) }}
                }
              </td>
              <td>{{ 'paymentTerm.' + billingRequest.paymentTerms | translate }}</td>
              <td>
                @if (billingRequest.invoice?.isAccounted()) {
                  <span class="text-success">Yes</span>
                }
                @if (!billingRequest.invoice?.isAccounted()) {
                  <span class="text-warning">No</span>
                }
              </td>
              <td class="text-success">
                @if (billingRequest.deferred) {
                  <span class="badge bg-success">Deferred</span>
                }
                @if (!billingRequest.deferred && billingRequest.invoice) {
                  <span
                    [ngClass]="billingRequest.invoice.getStatusClass()" class="badge">
                    {{ 'invoiceStatus.' + billingRequest.invoice.status | translate }}
                  </span>
                }
              </td>
              <td class="text-end">
                @if (billingRequest.invoice?.isWaitingForApproval()) {
                  <button
                    (click)="openBillingLineModal(billingRequest)"
                    class="btn btn-outline-secondary btn-sm me-2">
                    <i class="bi bi-pen me-2"></i>Edit
                  </button>
                }
                @if (billingRequest.invoice && billingRequest.invoice.id && billingRequest.invoice.reference) {
                  <a
                    [href]="invoiceService.getDownloadPdfUrl(billingRequest.invoice.id)"
                    [download]="billingRequest.invoice.reference + '.pdf'" class="btn btn-outline-success btn-sm me-2">
                    <i class="bi bi-download me-2"></i>Download
                  </a>
                }
                @if (billingRequest.invoice?.isWaitingForApproval()) {
                  <button
                    (click)="updateStatus('invoice_validated', billingRequest)"
                    class="btn btn-outline-success btn-sm me-2">
                    <i class="bi bi-check-lg me-2"></i>Validate
                  </button>
                }
                @if (!billingRequest.invoice?.isPaid()) {
                  <button
                    (click)="delete(billingRequest)" appConfirm class="btn btn-outline-danger btn-sm">
                    <i class="bi bi-trash me-2"></i>Delete
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>

    <div class="batch-actions mt-4">
      <a [href]="invoiceService.getDownloadUrl(selectedBillingRequests, downloadMode)"
        [class.disabled]="!selectedBillingRequests.length"
        [download]="'invoices.' + downloadMode" class="btn btn-outline-primary fw-bold">
        <i class="bi bi-download me-2"></i>Download selection
      </a>

      <button (click)="updateStatus('invoice_validated')"
        [disabled]="!selectedBillingRequests.length"
        class="btn btn-outline-primary fw-bold ms-2" type="button">
        <i class="bi bi-flag me-2"></i>Validate selection
      </button>
    </div>
  </div>
</div>
